import * as Yup from "yup"
import { useFormik } from "formik";
import Field from "../../form/fields/Field";
import { Button } from "@mui/material";
import { store } from "../../../stores/Store";
import { AlertModal } from "../../..";
import CreateQuestionnaireForm from "./CreateQuestionnaireForm";

export default function QuestionnaireCopyForm ({questionnaire}) {

    const formik = useFormik({
    
        initialValues: {
            copyTo: null
        },

        validationSchema: Yup.object({
            copyTo: Yup.string().required(),
        }),

        onSubmit: async (values, actions) => {
            store.AlertStore.Close()
            if (values.copyTo === "answers") {
                AlertModal({width: "550px", body: <CreateQuestionnaireForm questionnaire={questionnaire} answersJson={questionnaire.answers} />})
            }
            if (values.copyTo === "preloaded_answers") {
                AlertModal({width: "550px", body: <CreateQuestionnaireForm questionnaire={questionnaire} preloadedAnswersJson={questionnaire.answers} />})
            }
        }
    })

    return (
        <form className="form" onSubmit={formik.handleSubmit}>
            <h2>Copy Questionnaire</h2>

            <div>
                <Field.Radio 
                    formik
                    name="copyTo"
                    value={formik.values.copyTo}
                    warning={formik.submitCount && formik.errors.copyTo ? formik.errors.copyTo : false}
                    onChange={(e) => formik.handleChange(e)}
                    options={[
                        {value: "answers", label: "Full copy", help: "Copy all answers and progress."},
                        {value: "preloaded_answers", label: "Prepopulate only", help: "Only use answers to prepopulate fields as the user is filling them in."}
                    ]}
                />
            </div>

            <div className="form-buttons">
                <Button
                    className="btn btn-sm" 
                    onClick={() => store.AlertStore.Close()}>
                    Cancel
                </Button>
                
                <Button 
                    className="btn btn-sm" 
                    type="submit" 
                    variant="contained" 
                    color="success" 
                    disabled={!formik.values.copyTo}>
                    Continue
                </Button>
            </div>
        </form>
    )
}